import { getRecordingProxyUrl, useCallRecording } from '@/hooks/useCallRecording';
import { LogSessionContentRow } from '@/shared/types/analytics';

/** Fetches call recording metadata for a session and derives the proxy URL. */
export const useCallRecordingForSession = (content?: LogSessionContentRow, enabled = true) => {
  const { recording, isLoading, hasRecording } = useCallRecording({
    sessionId: content?.session_id,
    enabled,
  });

  const recordingUrl =
    hasRecording &&
    recording?.account_id &&
    content?.desk_id &&
    content?.integration_id &&
    recording?.recording_sid &&
    recording?.session_id
      ? getRecordingProxyUrl({
          accountId: recording.account_id,
          deskId: content.desk_id,
          integrationId: content.integration_id,
          recordingSid: recording.recording_sid,
          channel: content.channel,
          sessionId: recording.session_id,
        })
      : null;

  return { recording, isLoading, hasRecording, showRecordingPlayer: !!recordingUrl, recordingUrl };
};
